var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCups2EmptyUpdated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 24,
    viewBox: "0 0 47 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.91751 23.7808L6.17667 21.315L12.3073 18.0274L12.6528 14.7397L2.85937 5.6986L3.20491 2.41093H8.16356L8.33633 0.76709H15.7743H23.2123L23.0395 2.41093H27.9981L27.6526 5.6986L15.9586 14.7397L15.6131 18.0274L21.0526 21.315L20.7934 23.7808H13.3555H5.91751ZM8.81723 4.05476H5.51146L5.42508 4.87668L8.47168 7.34243L8.81723 4.05476ZM22.0403 4.05476H25.346L25.2597 4.87668L21.6947 7.34243L22.0403 4.05476Z",
    fill: "#FFB800"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9274_73015",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 0,
    width: 32,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.897 23.7808H46.5815V0.76709H25.3954L25.2227 2.41093H30.1813L29.8358 5.6986L18.1418 14.7397L17.7962 18.0274L23.2358 21.315L22.9766 23.7808L15.897 23.7808Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9274_73015)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2104 23.7808L24.4695 21.315L30.6001 18.0274L30.9457 14.7397L21.1522 5.6986L21.4978 2.41093H26.4564L26.6292 0.76709H34.0671H41.5051L41.3323 2.41093H46.291L45.9454 5.6986L34.2515 14.7397L33.9059 18.0274L39.3455 21.315L39.0863 23.7808H31.6483H24.2104ZM27.1101 4.05476H23.8043L23.7179 4.87668L26.7645 7.34243L27.1101 4.05476ZM40.3331 4.05476H43.6389L43.5525 4.87668L39.9876 7.34243L40.3331 4.05476Z",
    fill: "#D9D7CF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCups2EmptyUpdated);
export default __webpack_public_path__ + "static/media/cups-2-empty-updated.76f865f2402631f090a9ae1ef8f3f164.svg";
export { ForwardRef as ReactComponent };